module.exports = __webpack_public_path__ + "assets/ceb451462bdad382befd0647fe26da3d.png";